/**
 * 모델
 * @window w_tb_excel_history
 * @category 엑셀출력기록
 */
export class ExcelHistoryModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 일자
   *
   * **data type** varchar(8)
   */
  readonly indate: string;

  /**
   * 출력자 사원코드
   *
   * **data type** varchar(8)
   */
  readonly inperid: string;

  /**
   * 출력자 사원명
   *
   * **data type** varchar(8)
   */
  readonly inpernm: string;

  /**
   * 출력 시간
   *
   * **data type** varchar(8)
   */
  readonly intime: string;

  /**
   * 출력일자
   *
   * **data type** varchar(8)
   */
  readonly prtdate: string;

  /**
   * 출력번호
   *
   * **data type** varchar(8)
   */
  readonly prtnum: string;

  /**
   * 출력사유
   *
   * **data type** varchar(8)
   */
  readonly remark: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(8)
   */
  readonly spjangcd: string;

  /**
   * 윈도우명 (영어)
   *
   * **data type** varchar(8)
   */
  readonly windowname: string;

  /**
   * 윈도우명 (한글)
   *
   * **data type** varchar(8)
   */
  readonly windownameH: string;

  constructor(data: any) {
    this.custcd = data.custcd || '';
    this.indate = data.indate || '';
    this.inperid = data.inperid || '';
    this.inpernm = data.inpernm || '';
    this.intime = data.intime || '';
    this.prtdate = data.prtdate || '';
    this.prtnum = data.prtnum || '';
    this.remark = data.remark || '';
    this.spjangcd = data.spjangcd || '';
    this.windowname = data.windowname || '';
    this.windownameH = data.windowname_h || '';
  }
}
